module.exports = __webpack_public_path__ + "09_face.aedb5207.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/09_face.png
// module id = G8wg
// module chunks = 0